import { z } from 'zod';

import { PaginationResponseSchema } from '@/shared/global.schema';

export const PurchaseReturnListItemSchema = z.object({
    id: z.string(),
    created_at: z.string(),
    updated_at: z.string(),
    user_id: z.string(),
    payment_id: z.string(),
    purchase_id: z.string(),
    return_reason: z.string().nullable(),
    total_items: z.number(),
    user_name: z.string(),
    purchase_invoice_number: z.string(),
    payment_total_price: z.coerce.number(),
    supplier_id: z.string(),
    supplier_name: z.string(),
});

export type TPurchaseReturnListItem = z.infer<
    typeof PurchaseReturnListItemSchema
>;

export const PurchaseReturnListResponseSchema = z.object({
    data: z.array(PurchaseReturnListItemSchema),
    pagination: PaginationResponseSchema,
});

export type TPurchaseReturnListResponse = z.infer<
    typeof PurchaseReturnListResponseSchema
>;

export const PurchaseReturnDetailsSchema = z.object({
    id: z.string(),
    created_at: z.string(),
    updated_at: z.string(),
    user_id: z.string(),
    payment_id: z.string(),
    purchase_id: z.string(),
    return_reason: z.string().nullable(),
    payment: z.object({
        id: z.string(),
        created_at: z.string(),
        updated_at: z.string(),
        user_id: z.string(),
        total_price: z.number(),
        type: z.string(),
        status: z.string(),
        payment_method: z.string(),
        transaction_id: z.string().nullable(),
    }),
    items: z.array(
        z.object({
            id: z.string(),
            created_at: z.string(),
            updated_at: z.string(),
            purchase_return_id: z.string(),
            product_variation_id: z.string(),
            product_name: z.string(),
            price: z.number(),
            quantity: z.number(),
            return_price: z.number(),
        }),
    ),
    purchase: z.object({
        id: z.string(),
        created_at: z.string(),
        updated_at: z.string(),
        supplier_id: z.string(),
        created_by: z.string(),
        payment_id: z.string(),
        invoice_number: z.string(),
        status: z.string(),
        note: z.string().nullable(),
    }),
    user: z.object({
        id: z.string(),
        created_at: z.string(),
        updated_at: z.string(),
        name: z.string(),
        email: z.string(),
        phone_number: z.string(),
        password: z.string(),
        status: z.string(),
        role_id: z.string(),
    }),
});

export type TPurchaseReturnDetails = z.infer<
    typeof PurchaseReturnDetailsSchema
>;

export const PurchaseReturnDetailsResponseSchema = z.object({
    data: PurchaseReturnDetailsSchema,
});

export type TPurchaseReturnDetailsResponse = z.infer<
    typeof PurchaseReturnDetailsResponseSchema
>;
